import RemoveModal from './RemoveModal';

export default RemoveModal;
